import { createSlice } from '@reduxjs/toolkit';

const reloadFeedbackDetailsSlice = createSlice({
    name: 'reloadFeedbackDetails',
    initialState: {
      value:false,
      reloadDashboard: false,
      switchToDashboardView: true,
      dashboardPayload: null,
    },
    reducers: {
      /*setReloadFeedbackDetails: (state, action) => {
        state.value = action.payload.value || false;
        state.reloadDashboard = action.payload.reloadDashboard || false;
        state.switchToDashboardView = action.payload.switchToDashboardView || false;
        state.dashboardPayload = null;
      },*/
      setReloadFeedbackDetails: (state, action) => {
        state.value = action.payload.value ?? state.value;
        state.reloadDashboard = action.payload.reloadDashboard ?? state.reloadDashboard;
        state.switchToDashboardView =
          action.payload.switchToDashboardView ?? state.switchToDashboardView;

        // ✅ Allow payload override instead of wiping it
        if (action.payload.dashboardPayload !== undefined) {
          state.dashboardPayload = action.payload.dashboardPayload;
        }
      },
    },
  },
);

export const { setReloadFeedbackDetails } = reloadFeedbackDetailsSlice.actions;
export default reloadFeedbackDetailsSlice.reducer;